import { getYear } from "../../utils/datetime_utils"
import { TextEditor } from "../TextEditor"
import { Trash2 } from "lucide-react"
export const WorkExperienceSection = ({ exp, onChange }) => {
    const handleFieldChange = (field, value) => {
        if (onChange) {
            onChange(exp.id, field, value);
        }
    };


    return (<div key={exp.id} className="py-4">
    {/* Organization */}
    <div className="flex">
        <input
            className="md:col-span-2 w-full px-2 py-2 border-b border-gray-200 font-semibold text-gray-800 bg-transparent focus:outline-none focus:border-indigo-300"
            value={exp.organization}
            onChange={(e) => handleFieldChange('organization', e.target.value)}
            />

        <button>
        <Trash2 size={20} color="red" aria-hidden="true" />
        </button>

    </div>


    <div className="grid grid-cols-1 md:grid-cols-4  md:items-end">
        <input 
            className="w-full px-2 py-2 border-b border-gray-200 mb-3 font-semibold text-gray-900 bg-transparent focus:outline-none focus:border-indigo-300" 
            value={exp.title} 
            onChange={(e) => handleFieldChange('title', e.target.value)}
        />

    {/* Dates aligned to right */}
    <div className="md:col-span-2 flex items-center justify-self-end">
        <input
        className="w-16 text-right px-2 py-2 border-b font-semibold border-gray-200 text-gray-600 bg-transparent focus:outline-none focus:border-indigo-300"
        value={getYear(exp.start_date)}
        onChange={(e) => handleFieldChange('start_date', e.target.value)}
        />
        <span className="text-gray-500 font-bold">-</span>
        <input
        className="w-16 text-right px-2 py-2 border-b font-semibold border-gray-200 text-gray-600 bg-transparent focus:outline-none focus:border-indigo-300"
        value={getYear(exp.end_date)}
        onChange={(e) => handleFieldChange('end_date', e.target.value)}
        />
    </div>
    </div>


        <div className="mt-3">
            <TextEditor 
                // initial={`<ul>${exp.description
                //     .map(point => `<li>${point}</li>`)
                //     .join("")}</ul>`} 
                initial={exp.description} 
                onChange={(value) => handleFieldChange('description', value)}
            />
        </div>
    </div>)
}